import React, { useState, useEffect } from "react";
import { Text, View, StyleSheet, Platform } from "react-native";

import fontStyles from "../../../fonts";
import AppTheme from "../../AppTheme";
import ManaDropdown from "../../common/dropdown/ManaDropdown";
import TrashIcon from "../../common/icons/integrations/TrashIcon";
import appStyles from "../../../appStyles";
import IntegrationRuleElement from "./IntegrationRuleElement";
import { hasItems } from "../../../../helpers/utils";
import IntegrationsHelper from "../IntegrationsHelper";

export default function IntegrationRuleDetails({
  integration,
  controller,
  showRulesSummary = false,
  showAssociation = false,
  isReadOnly = false,
  deleteRule, // action
  changeAssociation = () => {},
  onSelectedRuleChanged = () => {},
}) {
  const [rules, setRules] = useState(null);
  const [selectedRule, setSelectedRule] = useState({});
  const rulesHeaderText = showAssociation
    ? "Take all data that"
    : isReadOnly
    ? "Ignoring all data that is from"
    : "Ignore all data that";

  // Update rules
  useEffect(() => {
    const rulesList = integration.rules || [];
    setRules(rulesList.map((r) => IntegrationsHelper.formatRule(r)));

    if (integration.rule) {
      setSelectedRule(IntegrationsHelper.formatRule(integration.rule));
    } else {
      // Hack: some rules dont have discriminator
      setSelectedRule(rulesList[0]);
    }
  }, [integration.rule, integration.rules]);

  // ------------------------------------- METHODS -------------------------------------
  const onDeleteRule = () => {
    // Add integration fields to rule model for dialog confirm display
    deleteRule({
      ...integration,
      rule: selectedRule,
    });
  };

  return (
    <View style={[styles.container]}>
      {integration.website ? (
        <Text style={appStyles.captionThin} numberOfLines={1}>
          {integration.website}
        </Text>
      ) : null}

      {/* Rules list */}
      {hasItems(rules) ? (
        <View style={styles.rulesContainer}>
          <Text style={[fontStyles.caption, { marginVertical: 4 }]}>
            {rulesHeaderText}
          </Text>

          <ManaDropdown
            options={rules}
            field="name"
            hideIcon
            expand
            isDisabled={showRulesSummary || isReadOnly}
            selectedValue={selectedRule}
            onPickerValueChanged={(m) => {
              onSelectedRuleChanged(m);
            }}
            style={{
              backgroundColor: "#F3F2F1",
            }}
          />
        </View>
      ) : null}

      {/* Associated element */}
      {showAssociation ? (
        <View style={[styles.rulesContainer, { borderTopWidth: 0 }]}>
          <Text style={[fontStyles.caption, { marginVertical: 4 }]}>
            and associate it with:
          </Text>

          <IntegrationRuleElement
            data={integration}
            controller={controller}
            onPress={changeAssociation}
          />
        </View>
      ) : null}

      {/* Delete */}
      {deleteRule ? (
        <View style={styles.deleteContainer}>
          <TrashIcon />
          <Text style={styles.deleteText} onPress={onDeleteRule}>
            Delete rule
          </Text>
        </View>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingLeft: 28,
    paddingRight: 20,
    display: "flex",
    alignItems: "flex-start",
  },
  rulesContainer: {
    overflow: "visible",
    zIndex: 1000,
    width: "100%",
    borderTopColor: AppTheme.borderColor,
    borderTopWidth: 1,
    marginTop: 5,
  },
  deleteContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "row",
    paddingRight: 14,
    marginTop: 12,
  },
  deleteText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: MoodColors.VeryBad,
    textAlign: "center",
    marginLeft: 6,
  },
});
